module.exports = __webpack_public_path__ + "static/00046.3366031f.jpg";